import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake && pdfFonts.pdfMake.vfs ? pdfFonts.pdfMake.vfs : {};

// Shared table grid look (identical to the original per-table layout).
const tableLayout = {
  hLineWidth: function (i, node) {
    return i === 0 || i === node.table.body.length ? 2 : 1;
  },
  vLineWidth: function (i, node) {
    return i === 0 || i === node.table.widths.length ? 2 : 1;
  },
  hLineColor: function (i, node) {
    return i === 0 || i === node.table.body.length ? "black" : "gray";
  },
  vLineColor: function (i, node) {
    return i === 0 || i === node.table.widths.length ? "black" : "gray";
  },
};

const styles = {
  header: { fontSize: 18, bold: true },
  subheader: { fontSize: 10, bold: true },
  quote: { italics: true },
  small: { fontSize: 8 },
};

// Render a form's sections into a pdfmake table-body (rows).
// esignWidth differs between main (100) and child (50) permits.
function buildFormBody(sections, data, esignWidth) {
  var rows = [];
  (sections || []).map(function (res) {
    rows.push([{ text: "", border: [false, false, false, false] }]);
    rows.push([{ text: res.title, style: "subheader" }]);
    (res.form || []).map(function (item) {
      try {
        if (data[item.name] === undefined) {
          if (item.type === "freetext") {
            rows.push([{ text: "**" + item.label, style: "small", italics: true }]);
          } else {
            rows.push([{ text: item.label + ": " + "", style: "small" }]);
          }
        } else {
          if (item.type === "file" || item.type === "map") {
            data[item.name].map(function (fn) {
              rows.push([
                {
                  text: item.label + ": " + fn,
                  link:
                    (process.env.REACT_APP_IMAGE_URL || "").replace(/\/$/, "") + "/" + String(fn).replace(/^\//, ""),
                  style: "small",
                  italics: true,
                  color: "blue",
                },
              ]);
            });
          } else if (item.type === "esign") {
            if (data[item.name]) {
              rows.push([{ image: data[item.name], width: esignWidth }]);
            } else {
              rows.push([{ text: "", style: "small" }]);
            }
          } else if (item.type === "freetext") {
            rows.push([{ text: item.label, style: "small", italics: true }]);
          } else if (item.type === "checkbox") {
            var checkbox = data[item.name] === true ? "Yes" : "No";
            rows.push([{ text: item.label + ": " + checkbox, style: "small" }]);
          } else {
            rows.push([{ text: item.label + ": " + data[item.name], style: "small" }]);
          }
        }
      } catch (error) {
        console.log("Error Data Info!!");
      }
    });
    rows.push([{ text: "", border: [false, false, false, false] }]);
  });
  return rows;
}

export default function GeneralPermitPDF(generalpermit) {
  console.log(generalpermit);
  var permitno = generalpermit.code;
  var status = generalpermit.status;
  var userinfo = generalpermit.submittedBy;
  var discipline = generalpermit.discipline;
  var hostsystemowner = generalpermit.hostSystemOwner;
  var site = generalpermit.site;

  // All permit + checklist content is merged into ONE document so we only call
  // .open() once. Calling .open() per child was silently blocked by the browser
  // popup blocker ("Open PDF in new window blocked by browser"), which is why
  // checklists never appeared.
  var content = [];

  // --- main permit: header table + form sections ---
  content.push({
    table: {
      widths: ["33.33%", "33.33%", "33.33%"],
      headerRows: 1,
      body: [
        [
          { text: "Full Name\n" + (userinfo?.fullname || ""), style: "small" },
          { text: "Company\n" + (userinfo?.company || ""), style: "small" },
          { text: "Permit Number\n" + (permitno || ""), style: "small" },
        ],
        [
          { text: "Email\n" + (userinfo?.email || ""), style: "small" },
          { text: "Site\n" + (site?.code || ""), style: "small" },
          { text: "Status\n " + (status || ""), style: "small" },
        ],
        [
          { text: "Discipline\n" + (discipline?.code || ""), style: "small" },
          { text: "Host / System Owner\n" + (hostsystemowner?.email || ""), style: "small" },
          { text: "\n " + "", style: "small" },
        ],
      ],
    },
    layout: tableLayout,
  });
  content.push({
    table: {
      headerRows: 1,
      body: buildFormBody(generalpermit?.form?.sections, generalpermit.submission || {}, 100),
    },
    layout: tableLayout,
  });

  // --- child permits / checklists: each on a new page, same document ---
  var childrenData = generalpermit.children;
  (childrenData || []).map(function (childData) {
    var childForm = childData.form || {};
    // pageBreak forces each checklist onto its own page
    content.push({ text: childForm.title || "Checklist", style: "subheader", pageBreak: "before" });
    content.push({
      table: {
        widths: ["33.33%", "33.33%", "33.33%"],
        headerRows: 1,
        body: [
          [
            { text: "Full Name\n" + (userinfo?.fullname || ""), style: "small" },
            { text: "Company\n" + (userinfo?.company || ""), style: "small" },
            { text: "Permit Number\n" + (permitno || ""), style: "small" },
          ],
          [
            { text: "Email\n" + (userinfo?.email || ""), style: "small" },
            { text: "Site\n" + "-", style: "small" },
            { text: "Status\n " + (status || ""), style: "small" },
          ],
        ],
      },
      layout: tableLayout,
    });
    content.push({
      table: {
        headerRows: 1,
        body: buildFormBody(childForm.sections, childData.submission || {}, 50),
      },
      layout: tableLayout,
    });
  });

  var dd = {
    info: {
      title: "General Permit",
    },
    pageSize: "A4",
    content: content,
    styles: styles,
  };

  pdfMake.createPdf(dd).open();
}
